<template>
    <div style="height: 100%;">
        <entity-list
                :entities="aois"
                :operations="operations"
                :isDisabled="isDisabled"
                :isCheckedList="true"
                @checkedEntitiesChanged="onCheckedEntitiesChanged"
                :groupBy="groupBy"
                :selectedEntity.sync="selectedEntity"
        >
            <request-aoi-list-item slot-scope="{item}"
                                   :aoi="item"
            />
            <div slot="header" style="padding-right: 10px;">
                <v-btn
                        flat icon color="grey lighten-2"
                        @click.stop="showRequestConfigDialog=true"
                        :style="{'margin-right':'0px'}"
                        title="Параметры заявки"
                >
                    <v-icon>mdi-settings</v-icon>
                </v-btn>
                <v-btn v-if="checkedEntities.length"
                       flat icon color="grey lighten-2"
                       @click.stop="onSendRequestButtonClick"
                       :style="{'margin-right':'0px'}"
                       title="Сформировать заявку"
                >
                    <v-icon>mdi-send</v-icon>
                </v-btn>
            </div>
        </entity-list>
        <div style="height: 100%;width: 100%;display: flex;align-items: center;position: absolute;top:0"
             v-if="isDisabled">
            <v-card
                    color="grey darken-4"
                    dark
                    :style="{margin:'auto','z-index':1001,'min-width': '250px'}"
            >
                <v-card-text>
                    <div
                            v-if="requestState==='applicationFormation'"
                            style="display: flex;align-items: center"
                    >
                        <h3 style="display: inline-block;margin: 0;">
                            Формирование заявки
                        </h3>
                        <v-progress-circular
                                :style="{'margin-left':'20px'}"
                                indeterminate
                                color="blue darken-3"
                                class="mb-0"
                        ></v-progress-circular>
                    </div>

                    <div
                            v-if="requestState==='applicationForm'"
                            style="display: flex;align-items: center; flex-direction:column;padding: 10px 10px 0;"
                    >
                        <h3 style="display: inline-block;margin: 0;">
                            Файл заявки отправлен на почту
                        </h3>
                        <v-btn color="blue darken-2" dark style="margin-top: 15px"
                               @click="isDisabled = false"
                        >ОК
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <request-config-dialog
                :value="requestConfig"
                :show.sync="showRequestConfigDialog"
                @configUpdated="onConfigUpdated"
        />
        <aoi-config-dialog
                :value="editedAoi"
                :show.sync="showAoiConfigDialog"
                @aoiUpdated="onAoiUpdated"
        />
    </div>
</template>

<script>
    import Vue from 'vue'

    import EntityList from '@/components/entity-list/entity-list.vue'
    import RequestAoiListItem from './request-aoi-list-item'

    import RequestConfigDialog from './request-config-dialog'
    import AoiConfigDialog from './aoi-config-dialog'

    import moment from 'moment'

    moment.locale('ru');

    import firebase from 'firebase/app'
    import "firebase/functions"

    import {find} from 'lodash/collection'

    export default {
        props: {
            aois: {
                type: Array,
                default: () => []
            },
            selectedAoi: {
                type: String,
                default: null
            },
            requestConfig: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                selectedEntity: this.selectedAoi,
                groupBy: (item) => {
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return +today < item.creationTime ? 'Сегодня' :
                        moment(item.creationTime).format(moment(today).year() === moment(item.creationTime).year() ? "D MMMM" : "D MMMM YYYY");
                },
                checkedEntities: [],
                isDisabled: false,
                showRequestConfigDialog: false,
                showAoiConfigDialog: false,
                requestState: 'applicationFormation',
                operations: [
                    {
                        type: 'custom',
                        icon: 'mdi-settings',
                        title: 'Праметры',
                        onClick: (id) => this.onEditAoiButtonClick(id)
                    }
                ],
                editedAoi: null
            }
        },
        computed: {},
        methods: {
            updateSelectedAoi(val) {
                if (val !== this.selectedAoi)
                    this.$emit('update:selectedAoi', val);
            },
            onCheckedEntitiesChanged(val) {
                this.checkedEntities = val;
            },
            onSendRequestButtonClick() {
                if (!this.requestConfig) {
                    this.showRequestConfigDialog = true;
                    return;
                }

                this.isDisabled = true;
                this.requestState = 'applicationFormation';

                const sendRequest = firebase.functions().httpsCallable('sendRequest');

                sendRequest(this.checkedEntities)
                    .then(result => result.data)
                    .then(({status}) => {
                        if (status === 'Ok') {
                            this.requestState = 'applicationForm';
                            this.$emit('entityUpdated', this.checkedEntities.map(id => ({
                                id,
                                data: {
                                    status: 'sent'
                                }
                            })))
                        }
                    })
                    .catch(() => this.isDisabled = false);
            },
            onConfigUpdated(val) {
                this.$emit('requestConfigUpdated', val);
            },
            onAoiUpdated(val) {
                this.$emit('entityUpdated', {
                    id: this.editedAoi.id,
                    data: val
                })
            },
            onEditAoiButtonClick(aoiId) {
                this.editedAoi = find(this.aois, ({id}) => aoiId === id);
                this.showAoiConfigDialog = true;
            }
        },

        components: {
            EntityList,
            RequestAoiListItem,
            RequestConfigDialog,
            AoiConfigDialog
        },

        watch: {
            selectedEntity(newVal) {
                this.updateSelectedAoi(newVal);
            },
            selectedAoi(newVal) {
                this.selectedEntity = newVal;
            }
        }
    }
</script>

<style scoped>

</style>
